import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import { ErrorBoundary } from './components/ErrorBoundary';
import './index.css';

// Automatically recover from stale asset chunk 404s when a new deployment occurs
window.addEventListener('vite:preloadError', () => {
  console.warn('[Vite Deployment Notice]: Stale chunk detected, refreshing application to fetch latest build...');
  window.location.reload();
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);

